import type { ReactNode } from 'react';
import { cn } from './cn';

interface ToolbarProps {
  children: ReactNode;
  className?: string;
}

export const Toolbar = ({ children, className }: ToolbarProps) => (
  <div className={cn('flex flex-wrap items-center gap-3 py-3 fade-in', className)}>
    {children}
  </div>
);
